<template>
  <al-modal
    :cta-label="$t(tokens.cta)"
    :heading="$t('challengeCancelModal.heading')"
    :close-label="$t(tokens.dismiss)"
    name="cancel-challenge-modal"
    @cta="onCtaClick">
    <div class="row align-center">
      <div class="col-full">
        <p>{{ $t(tokens.subtitle) }}</p>
      </div>
    </div>
  </al-modal>
</template>

<script lang="ts">
import { AlModal } from '@mc-alberta/alcapone'
import { computed, defineComponent, getCurrentInstance } from '@vue/composition-api'

export default defineComponent({
  name: 'CancelChallengeModal',
  components: { AlModal },
  setup() {
    const { proxy } = getCurrentInstance()

    const tokens = computed(() => {
      if (proxy.$store.getters.isLoggedIn) {
        return {
          subtitle: 'challengeCancelModal.returnUserContent',
          cta: 'button.continue',
          dismiss: 'button.goBack'
        }
      }

      return {
        subtitle: 'challengeCancelModal.content',
        cta: 'challengeCancelModal.cta',
        dismiss: 'challengeCancelModal.exit'
      }
    })

    /**
     * Cancels the authentication session.
     */
    function onCtaClick() {
      proxy.$store.dispatch('cancelAuthSession')
    }

    return {
      tokens,
      onCtaClick
    }
  }
})
</script>
